import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AccessDeniedDialogService {
  private readonly dialogRequestSource = new Subject<string>();
  readonly dialogRequest$ = this.dialogRequestSource.asObservable();

  private isOpen = false;

  open(message: string): void {
    if (this.isOpen) return;
    this.isOpen = true;
    this.dialogRequestSource.next(message);
  }

  close(): void {
    this.isOpen = false;
  }
}
